import { DialogComponent } from "@theme/dialog";

const AUTO_OPEN_HASH = '#surprise-me';

if (!customElements.get('surprise-dialog')) {
  class SurpriseDialog extends DialogComponent {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      window.addEventListener('hashchange', this.#handleHashChange);
      this.#handleHashChange();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      window.removeEventListener('hashchange', this.#handleHashChange);
    }

    /**
     * Opens the dialog when the URL hash is `#surprise-me`.
     * The hash is stripped afterwards so the same link can be clicked again.
     */
    #handleHashChange = () => {
      if (window.location.hash !== AUTO_OPEN_HASH) return;

      // Only the first dialog on the page reacts, in case the snippet is rendered more than once.
      if (document.querySelector('surprise-dialog') !== this) return;

      // The header block wrapper is `hidden lg:block`, so on mobile this markup sits inside a
      // `display: none` ancestor. `showModal()` there paints nothing but still makes the rest of
      // the page inert, and only the Escape key can dismiss it, which phones do not have.
      if (!this.#isRenderable()) return;

      history.replaceState(null, '', window.location.pathname + window.location.search);

      if (this.elements.dialog?.open) return;

      this.open();
    };

    /**
     * Checks whether the element would actually be painted if the dialog opened.
     *
     * @returns {boolean} True when neither this element nor any ancestor is hidden.
     */
    #isRenderable() {
      // Not available before Safari 17.4, which still covers a chunk of the mobile traffic
      // this guard exists for, so fall back to walking the ancestors.
      if (typeof this.checkVisibility === 'function') return this.checkVisibility();

      for (let element = this; element instanceof Element; element = element.parentElement) {
        if (window.getComputedStyle(element).display === 'none') return false;
      }

      return true;
    }

    open() {
      super.open();
      this.querySelector('surprise-product')?.showRandomProduct();
    }
  }
  customElements.define('surprise-dialog', SurpriseDialog);
}